// GENERATED by tools/codemods/gen-block-groups.mjs — do not edit.
// Regenerate: pnpm gen:block-groups

/** Block type → family for the data-<ns>-group attribute. */
export const BLOCK_GROUPS: Record<string, string> = {
  AccountCreatePassword: 'auth',
  AchievementsWidget: 'lms',
  AcmePartnerBadge: 'misc',
  ActivityBlock: 'activity',
  ActivityBlockBtk: 'activity',
  ActivityCertificates: 'activity',
  ActivityEntries: 'activity',
  ActivityFeed: 'activity',
  ActivityRow: 'activity',
  ActivityStatistics: 'activity',
  ActivityTimeline: 'activity',
  AdBanner: 'promo',
  ArticleBody: 'blog',
  ArticleCarousel: 'blog',
  ArticleFilterSidebar: 'blog',
  ArticleGrid: 'blog',
  AuthForm: 'auth',
  AutoScrollMarquee: 'rail',
  BackgroundGlow: 'layout',
  BadgeGrid: 'gamification',
  Band: 'layout',
  BlogArticleGrid: 'blog',
  BlogAuthor: 'blog',
  BlogFeaturedHero: 'blog',
  BlogsList: 'blog',
  ButtonGroup: 'tabs',
  CalendarBox: 'calendar',
  CalendarView: 'calendar',
  CalendlyBlock: 'embeds',
  CampsAndCompetitions: 'rail',
  CategoryCarousel: 'rail',
  CategoryFilterPills: 'discovery',
  CategoryGrid: 'grid',
  CategoryMenu: 'nav',
  CategorySelector: 'discovery',
  CategorySliderBlock: 'rail',
  CategoryTree: 'discovery',
  ChannelDetailLayout: 'system',
  ChannelDiscoveryLayout: 'system',
  Columns: 'layout',
  ComingSoon: 'promo',
  CommentsBlock: 'system',
  CommunityCreate: 'community',
  CommunityGroupDetailBlock: 'community',
  CommunityGroupList: 'community',
  CommunitySidebar: 'community',
  CompetencyAssessments: 'competency',
  CompetencyList: 'competency',
  CompetencyNominations: 'competency',
  CompetencyStatus: 'competency',
  CompetencyWizard: 'competency',
  Container: 'layout',
  CourseCard: 'course',
  CourseDetail: 'course-detail',
  CourseDetailEnrollStatus1: 'course-detail',
  CourseDetailMain1: 'course-detail',
  CourseDetailParticipants: 'course-detail',
  CourseDetailPurchaseBox: 'course-detail',
  CourseDetailRelatedCourses: 'course-detail',
  CourseDetailSimilarCourses: 'course-detail',
  CourseDetailStudyAids: 'course-detail',
  CourseDetailTop1: 'course-detail',
  CourseDetailTrainers: 'course-detail',
  CourseFilterSidebar: 'course',
  CourseGrid: 'grid',
  CourseOffer: 'course',
  CourseRow: 'rail',
  CourseRowTabs: 'rail',
  CourseStatusPieChart: 'course',
  CreateBlogForm: 'blog',
  CreateSocialGroupForm: 'akademi-net',
  CtaBand: 'cta',
  CtaCardModern: 'cta',
  DemandForm: 'forms',
  DemandFormBlock: 'forms',
  Divider: 'layout',
  DocumentFilterSidebar: 'documents',
  DocumentGrid: 'documents',
  DocumentLibrary: 'documents',
  DynamicFormBlock: 'form',
  EmbeddedVideo: 'embeds',
  EntityBody: 'lms',
  EventFilterBar: 'calendar',
  EventFilterSidebar: 'calendar',
  EventGrid: 'calendar',
  EventList: 'calendar',
  FaqAccordion: 'text',
  FeatureGrid: 'grid',
  FollowersList: 'community',
  FullBadge: 'gamification',
  FullHeightDiscovery: 'discovery',
  FullHeightMobilePromo: 'promo',
  FullHeightPodcast: 'media',
  FullHeightStats: 'stats',
  GamificationPanel: 'gamification',
  GamificationPanelV2: 'gamification',
  GamificationPanelV3: 'gamification',
  GamificationProfile: 'gamification',
  GamificationStats: 'gamification',
  HelpArticleFeedbackForm: 'help-center',
  HelpArticleSearch: 'help-center',
  HeroBanner: 'hero',
  HeroCarousel: 'hero',
  HeroCategoryBanner: 'hero',
  HeroCinematic: 'hero',
  HeroDualBanner: 'hero',
  HeroEditorial: 'hero',
  HeroFeatureRail: 'hero',
  HeroFullHeightBanner: 'hero',
  HeroFullHeightDiscovery: 'discovery',
  HeroFullHeightPodcast: 'media',
  HeroFullHeightStats: 'stats',
  HeroPlaylistRail: 'hero',
  HeroPromoRail: 'hero',
  HeroSignalDeck: 'hero',
  HeroSlider: 'hero',
  HeroSplit: 'hero',
  HeroSplitRotator: 'hero',
  HeroSpotlight: 'hero',
  HeroSpotlightCards: 'hero',
  HeroTriColumn: 'hero',
  HeroVideo: 'hero-video',
  HeroVideoBackground: 'hero-video',
  HistoryWriter: 'system',
  HomeworkDetail: 'learning',
  HomeworkList: 'learning',
  HtmlBlock: 'html',
  HubSpotFormBlock: 'embeds',
  HubSpotMeetingsBlock: 'embeds',
  Image: 'media',
  JourneyDetail: 'journeys',
  JourneyDetailV2: 'journeys',
  JourneyGrid: 'journeys',
  LastCourse: 'user-state',
  LeaderboardFull: 'gamification',
  LeaderboardTable: 'gamification',
  LearningJourneyPlans: 'journeys',
  LearningJourneys: 'journeys',
  LearningParticipationStatistics: 'reporting',
  LearningParticipationTable: 'reporting',
  LearningPathV2: 'learning',
  LessonPlayer: 'course-player',
  LevelProgression: 'gamification',
  LibraryClient: 'system',
  LiveCalendar: 'calendar',
  LiveCalendarBox: 'calendar',
  LiveNowStrip: 'rail',
  LiveSessionRail: 'akademi-net',
  LoginForm: 'auth',
  ManagerList: 'akademi-net',
  MandatoryCourseList: 'akademi-net',
  MandatoryCoursesPieChart: 'akademi-net',
  MarketplaceAddressSelect: 'marketplace',
  MarketplaceBankTransferInstructions: 'marketplace',
  MarketplaceCartItems: 'marketplace',
  MarketplaceCartSummary: 'marketplace',
  MarketplaceCatalogGrid: 'marketplace',
  MarketplaceCatalogHero: 'marketplace',
  MarketplaceCheckoutCta: 'marketplace',
  MarketplaceCheckoutStepper: 'marketplace',
  MarketplaceCouponCode: 'marketplace',
  MarketplaceCourseGrid: 'marketplace',
  MarketplaceCoursePurchaseBox: 'marketplace',
  MarketplacePaymentMethod: 'marketplace',
  MarketplacePendingOrders: 'marketplace',
  MediaCardRow: 'media',
  MetricRow: 'stats',
  MicroContentGrid: 'micro',
  MicroContentItem: 'micro',
  MicroContentRail: 'micro',
  MicroContentTypeGrid: 'micro',
  MicroFavoritesRail: 'micro',
  MicroListingLayout: 'system',
  MicroRecommendationRail: 'micro',
  MicroResumeRefresher: 'micro',
  MicroStatsStrip: 'micro',
  MobileAppPromo: 'promo',
  MobileAppShowcase: 'promo',
  MyActivityCertificates: 'my-learning',
  MyCertificates: 'my-learning',
  MyCourses: 'my-learning',
  MyCoursesList: 'my-learning',
  MyLearningStats: 'my-learning',
  NewsBody: 'blog',
  NewsList: 'blog',
  NotificationList: 'notifications',
  NotificationsTimeline: 'user-state',
  OpenSurveys: 'forms',
  PageContent: 'chrome',
  PartnersGrid: 'grid',
  PendingApprovals: 'approvals',
  PendingEvaluationFormsSlider: 'user-state',
  PendingTerms: 'approvals',
  PillarStack: 'grid',
  PlanTimeline: 'akademi-net',
  PlansPricing: 'nav',
  PluralsightHero: 'hero',
  PluralsightOutcomeGrid: 'grid',
  PluralsightProofBand: 'stats',
  PluralsightTopicGrid: 'grid',
  Podcasts: 'media',
  ProDetailCard: 'akademi-net',
  ProfileBadges: 'profile',
  ProfileBio: 'profile',
  ProfileCard: 'profile',
  ProfileCourses: 'profile',
  ProfileDetailsSummary: 'profile',
  ProfileEdit: 'profile',
  ProfileGivenCourses: 'profile',
  ProfileHero: 'profile',
  ProfileManagerStats: 'profile',
  ProfileMobileQr: 'profile',
  ProfilePendingForm: 'profile',
  ProfilePublic: 'profile',
  ProfileSettings: 'profile',
  ProfileStats: 'profile',
  ProfileYokEducation: 'profile',
  RankedShowcase: 'learning',
  RelatedArticles: 'lms',
  RichText: 'text',
  ScanQrToEnroll: 'course',
  SegmentedTabs: 'akademi-net',
  SeriesDetailLayout: 'system',
  SeriesModuleRail: 'video',
  SeriesPlayerLayout: 'system',
  ShortsFeed: 'video',
  ShortsRail: 'rail',
  SiteShell: 'chrome',
  SocialGroupDetail: 'community',
  SocialGroupGrid: 'community',
  Spacer: 'layout',
  StatsCourseTable: 'reporting',
  StatsPanel: 'reporting',
  SubscribeCard: 'cta',
  SwaggerEmbed: 'docs',
  TagSelector: 'akademi-net',
  TaskList: 'learning',
  TeamAnalyticsReports: 'team',
  TeamBarChart: 'team',
  TeamMandatoryChart: 'team',
  TeamMemberList: 'team',
  TeamNavbarV2: 'team',
  TeamStats: 'team',
  TeamsStatsGraph: 'team',
  Testimonials: 'proof',
  TestimonialsBento: 'proof',
  Timeline: 'timeline',
  Top10Row: 'rail',
  TrainerManageAttendees: 'lms',
  TrainingRail: 'akademi-net',
  TypeformBlock: 'embeds',
  UdemyCourseDetail: 'course-detail',
  VerticalTeamMemberList: 'team',
  VideoCarousel: 'tube',
  VideoDetailLayout: 'system',
  VideoModuleGrid: 'video',
  VideoModuleHero: 'video',
  VideoModuleRail: 'video',
  VideoPlayerHero: 'hero',
  VideoRow: 'rail',
  WikiAuthor: 'wiki',
  WikiBreadcrumbs: 'wiki',
  WikiPageMeta: 'wiki',
  WikiPrevNext: 'wiki',
  WikiSearchResults: 'wiki',
  WikiToc: 'wiki',
  WikiTreeBlock: 'wiki',
  WikiTreeNav: 'discovery',
  WildTvHero: 'hero',
  YearInReview: 'lms',
};
